<template>
  <div class="main-div">
    <img class="mb-3" src="../assets/img/logo.png"/>
    <div class="login-div">
      <p class="mt-3 mb-3 text-center"> Enter email to reset password </p>
      <b-form @submit.prevent="forgetPassword()" class="ml-4 mr-4 mb-4">
        <b-form-group id="emailGroup">
          <b-form-input id="email"
                      type="email"
                      name="email"
                      v-model="email"
                      v-validate="'required|email'"
                      :class="{'input': true, 'is-danger': errors.has('email') }"
                      required
                      placeholder="Email">
          </b-form-input>
          <i v-show="errors.has('email')" class="fa fa-warning"></i>
          <span v-show="errors.has('email')"
                class="help is-danger">{{ errors.first('email') }}</span>
        </b-form-group>

      <b-button type="submit" class="w-100" variant="warning">
        Submit
      </b-button>

    </b-form>
    </div>

 </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'ForgetPassword',
  data() {
    return {
      email: null,
    };
  },
  methods: {
    async forgetPassword() {
      try {
        await API.post('Accounts/reset', {
          email: this.email,
        });
        await this.$notify({
          group: 'sitewide',
          title: 'Success!',
          type: 'success',
          text: `Reset password link has been sent to ${this.email}.`,
        });
        this.$router.push('login');
      } catch (error) {
        const message = error.response.data.error.message;
        if (message.match(/Email has not been verified/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Email not verified',
          });
        } else if (message.match(/Email not found/gi)) {
          this.$router.push('notification');
        }
      }
    },
    register() {
      this.$router.push('registration');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div {
  background-color: #2c3e50;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}

.login-div {
  background-color: white;
  width: 30%;
  height: 175px;
  border-radius: 3px;
}

.w-100 {
  width: 100%;
}

.font-size {
  font-size: 14px;
  color: grey;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/forgetpassword.vue